export default class SessionManager {
  static readonly SESSION_STORAGE_KEY = 'surveySession';
  static readonly SESSION_ENABLED = false;

  private surveySessionLocal: string | null = null;
  constructor() {
    this.surveySessionLocal =
      localStorage.getItem(SessionManager.SESSION_STORAGE_KEY) || null;
  }

  createSession<T extends { type?: string; id?: string }>(
    sessionId: string,
    slug: string,
    facilityId: number,
    { type, id }: T
  ) {
    if (!SessionManager.SESSION_ENABLED) return;
    if (localStorage.getItem(SessionManager.SESSION_STORAGE_KEY)) {
      SessionManager.deleteSession();
    }
    localStorage.setItem(
      SessionManager.SESSION_STORAGE_KEY,
      JSON.stringify({
        sessionId,
        slug,
        facilityId,
        ...(type && { type }),
        ...(id && { id }),
      })
    );
  }

  getSession() {
    return this.surveySessionLocal ? JSON.parse(this.surveySessionLocal) : '';
  }

  static deleteSession() {
    localStorage.removeItem(SessionManager.SESSION_STORAGE_KEY);
  }

  validateAndGetSessionData<T extends { type?: string; id?: string }>(
    params: T
  ) {
    if (!this.surveySessionLocal) return null;
    const surveySessionLocal = JSON.parse(this.surveySessionLocal);

    const { type: queryType, id: queryId } = params;

    const { type: sessionType, id: sessionFacilityId } = surveySessionLocal;

    const everyAttrIsValid =
      queryType || queryId || sessionType || sessionFacilityId;

    if (
      everyAttrIsValid &&
      (sessionFacilityId !== queryId || sessionType !== queryType)
    ) {
      SessionManager.deleteSession();
      return null;
    }

    return surveySessionLocal;
  }
}
